export const minIconsTableColumnsWidth = {
  iconLink: 230,
};
